import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import * as jobActions from '../jobActions';import * as employeeActions from '../employeeActions';
import valueFilters from '../valueFilters';
import globalRelay from '../globalRelay';
import util from '../util';
import componentServices from '../componentServices';

import { SearchForm, Spinner } from './sharedComponents';

const _searchProfileItem = 'jobSearchParamKey';
export default class JobSearchForm extends React.PureComponent<any,any> {
	private _searchParameters;
	
	constructor (props) {
		super(props);

		this.onSearch = this.onSearch.bind(this);
		this.onSearchCleared = this.onSearchCleared.bind(this);

		this._searchParameters = globalRelay.config!.search.params[props.searchKey] || globalRelay.config!.search.params.default;
	}

	onSearch (searchState) {
		const { searchKey } = this.props;
		const currentEmployee = componentServices.securityContext.getCurrentEmployee();
		const preferredSearchParamKey = currentEmployee.getProfileValue(_searchProfileItem);
		const searchParameterKey = searchState.searchParameter.key;
		const searchText = valueFilters.clean(searchState.searchText);
		const params:any = {};
		let canceled = false;
		const cancelAction = () => {
			canceled = true;
			actions.deleteModal({ key: searchKey });
		};

		actions.pushModal({ key: searchKey, component: (<Spinner cancelAction={cancelAction}/>) });

		switch (searchParameterKey) {
		case 'client':
			params.client = {
				firstName: searchText,
				lastName: searchText,
				emailAddress: searchText
			};

			break;
		case 'contact':
			params.contact = {
				firstName: searchText,
				lastName: searchText,
				emailAddress: searchText
			};

			break;
		case 'phone':
			params.phone = {
				number: util.phoneHelper.formatInternational(searchText)
			};

			break;
		case 'address':
			params.address = {
				street: searchText
			};

			break;
		case 'accountManager':
			params.employeeRole = 'account-manager';
			params.name = searchText;

			break;
		case 'estimator':
			params.employeeRole = 'estimator';
			params.name = searchText;
	
			break;
		default:
			params[searchParameterKey] = searchText;
			break;
		}

		if (searchParameterKey !== preferredSearchParamKey) {
			employeeActions.setProfileValue({ name: _searchProfileItem, value: searchParameterKey });
		}

		jobActions.searchJobs(params).then(jobs => {
			if (!canceled) {
				actions.setSearchResults({ key: searchKey, searchParameter: searchState.searchParameter, searchText: searchText, list: jobs });
			}
		}).finally(() => {
			cancelAction();
		});
	}

	onSearchCleared () {
		const { searchKey } = this.props;
		actions.deleteSearchResults({ key: searchKey });
	}

	render () {
		const { searchKey } = this.props;
		const searchResults = componentServices.store.getIn(['viewState', 'searchResults', searchKey]);
		const currentEmployee = componentServices.securityContext.getCurrentEmployee();
		const preferredSearchParameter = this._searchParameters && _.find(this._searchParameters, { key: currentEmployee.getProfileValue(_searchProfileItem) });

		return (<SearchForm
			onSearch={this.onSearch}
			onSearchCleared={ this.onSearchCleared }
			searchParameters={ this._searchParameters }
			initialSearchText={ searchResults && searchResults.searchText }
			initialActiveParameter={ (searchResults && searchResults.searchParameter) || preferredSearchParameter }
			searchTextTest={ /[\w\d]{3}/ } />
		);
	}
}